import { useNavigate } from "react-router-dom";
import { X, Trash2, ShoppingBag } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useCart } from "@/context/CartContext";
import { assetUrl } from "@/lib/api";

export default function CartDrawer() {
  const { items, remove, subtotal, open, setOpen, count } = useCart();
  const nav = useNavigate();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="w-full sm:max-w-md flex flex-col" data-testid="cart-drawer">
        <SheetHeader>
          <SheetTitle className="font-serif-display text-2xl text-[#2E1065] flex items-center gap-2">
            <ShoppingBag className="w-5 h-5" /> Your Cart ({count})
          </SheetTitle>
        </SheetHeader>
        {items.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center text-center text-slate-400 gap-3">
            <ShoppingBag className="w-12 h-12 opacity-30" />
            <p className="text-sm">Your cart is empty.</p>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto py-4 space-y-4">
              {items.map((i) => (
                <div key={i.product_key} data-testid={`cart-item-${i.product_key}`} className="flex gap-3 items-center">
                  <div className="w-14 h-16 rounded-lg bg-slate-100 overflow-hidden shrink-0">
                    {i.cover_url && <img src={assetUrl(i.cover_url)} alt={i.title} className="w-full h-full object-cover" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-[#0A0F1D] truncate">{i.title}</p>
                    <p className="text-xs text-slate-500">Qty {i.quantity} · ${i.price.toFixed(2)}</p>
                  </div>
                  <button data-testid={`cart-remove-${i.product_key}`} onClick={() => remove(i.product_key)} className="p-2 text-slate-400 hover:text-red-500">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>
            <div className="border-t pt-4 space-y-4">
              <div className="flex justify-between text-sm font-semibold">
                <span className="text-slate-500">Subtotal</span>
                <span data-testid="cart-subtotal" className="text-[#2E1065] text-lg">${subtotal.toFixed(2)}</span>
              </div>
              <Button data-testid="cart-checkout-button" onClick={() => { setOpen(false); nav("/cart"); }}
                className="w-full h-12 bg-[#3B1F6E] hover:bg-[#2E1065] text-white rounded-xl font-semibold">
                Proceed to Checkout
              </Button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
